// extracted by mini-css-extract-plugin
module.exports = {"control":"LinksGroup_control__1OYRD","link":"LinksGroup_link__nRz1t","link2":"LinksGroup_link2__puWe_","chevron":"LinksGroup_chevron__0QSrF"};